import {
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_ANNOUNCEMENTS_FAILURE,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  RESET_ANNOUNCEMENT_STATE,
} from './announcementTypes';

const initialState = {
  announcements: [],
  totalAnnouncements: 0,
  loading: false,
  error: null,
  successMessage: null,
};

const announcementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANNOUNCEMENTS_REQUEST:
    case CREATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case FETCH_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        announcements: action.payload.data || [],
        totalAnnouncements: action.payload.totalRecords || 0,
      };

    case FETCH_ANNOUNCEMENTS_FAILURE:
    case CREATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
      };

    case RESET_ANNOUNCEMENT_STATE:
      return initialState;

    default:
      return state;
  }
};

export default announcementReducer;
